// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MinusSquareTwoToneSvg from "@fishx/icons-svg/es/asn/MinusSquareTwoTone";
import FishxIcon from '../components/FishxIcon';

var MinusSquareTwoTone = function MinusSquareTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MinusSquareTwoToneSvg
  }));
};

MinusSquareTwoTone.displayName = 'MinusSquareTwoTone';
export default React.forwardRef(MinusSquareTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MinusSquareTwoTone.js
// module id = 3143
// module chunks = 0